import i18n from 'i18next';

import { addModal } from '@/exceed';

export default async ({
  schema, title, onSaveButtonClick, className,
}) => {
  const actions = [{
    action: 'save',
    element: 'button',
    color: 'brand',
    size: 'medium',
    text: i18n.t('save'),
    getIsDisabled: ({ hasFormError }) => hasFormError,
  }, {
    action: 'cancel',
    variant: 'ghost',
    size: 'medium',
    element: 'button',
    text: i18n.t('cancel'),
  }];

  const { type, payload } = await addModal({
    actions,
    isFullScreen: true,
    title,
    schema,
    className,
    hasCloseButton: true,
  });

  if (type !== 'save') return;

  await onSaveButtonClick({ payload });
};
